// Imports de módulos
import { CommonModule } from '@angular/common';
import { MATERIAL_MODULES } from '../material.config';

// Imports de componentes/pipes (standalone)
import { ModalWindowComponent } from './modal-window.component';
import { SafeHtmlPipe } from './Pipes/sanitize.pipe';

// Imports de servicios
import { ModalWindowService } from './modal-window.service';

// Array con los módulos a importar en componentes
export const MODAL_WINDOW_IMPORTS = [
  CommonModule,
  ...MATERIAL_MODULES,
  SafeHtmlPipe
];

// Exports para usar en otros componentes
// export { ModalWindowComponent, SafeHtmlPipe };

// Providers (van en app.config.ts)
export const MODAL_WINDOW_PROVIDERS = [
  ModalWindowService
];